import React from 'react';
import { COLORS, Color } from '../../styles/variables';

interface SuccessIconProps {
  color?: Color;
  size?: number;
}

const SuccessIcon: React.FC<SuccessIconProps> = ({ color = COLORS.grey80, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.3,11.3 L10.6,14.6 L15.7,7.4 M11.5,22.5 C17.5751322,22.5 22.5,17.5751322 22.5,11.5 C22.5,5.42486775 17.5751322,0.5 11.5,0.5 C5.42486775,0.5 0.5,5.42486775 0.5,11.5 C0.5,17.5751322 5.42486775,22.5 11.5,22.5 Z"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default SuccessIcon;
